import { render, staticRenderFns } from "./AtabatIndexView.vue?vue&type=template&id=4fc9c9e1&scoped=true"
import script from "./AtabatIndexView.vue?vue&type=script&lang=js"
export * from "./AtabatIndexView.vue?vue&type=script&lang=js"
import style0 from "./AtabatIndexView.vue?vue&type=style&index=0&id=4fc9c9e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc9c9e1",
  null
  
)

export default component.exports